<template>
    <ui-Installation
        v-on="$listeners"
        v-show="inFilterSpace()"
        :show="show"
        :hidden="hidden"
        :name="installation.name"
        :type="installation.type"
        :outService="status.isOutService()"
        :modeHeat="modeHeat"
    >
        <template v-slot:installationModal>
            <ui-Modal ref="alertModeChange" :closeText="$dicc.close">
                <template v-slot:head>
                    <inline-svg
                        :src="getImage('icons/streamline-icon-road-sign-stop@450x450.svg')"
                        style="height:150px"
                    ></inline-svg>
                </template>
                <template v-slot:body>
                    <p>{{ $dicc.alertModeChange.description }}</p>
                    <p>{{ $dicc.alertModeChange.steps.title }}</p>
                    <ol>
                        <li>{{ $dicc.alertModeChange.steps['1'] }}</li>
                        <li>{{ $dicc.alertModeChange.steps['2'] }}</li>
                        <li>{{ $dicc.alertModeChange.steps['3'] }}</li>
                    </ol>
                    <p>{{ $dicc.alertModeChange.result }}</p>
                </template>
            </ui-Modal>
        </template>
        <template v-slot:installationProperties>
            <ui-InstallationProperties
                :show="tStates.length > 0"
                :active="status.isOn()"
                :modeHeat="status.isModeHeat()"
                @setHeat="setModeHeat(true)"
                @setCool="setModeHeat(false)"
                @stop="stop()"
            >
            </ui-InstallationProperties>
        </template>
        <template v-slot:device v-if="devices">
            <Device
                v-for="device in $fns.sortByProperty(devices, 'name')"
                :key="device.reference"
                v-show="filtersSpaces.length == 0 || filtersSpaces.includes(device.space_id)"
                :ref="`Device_${device.reference}`"
                :device="device"
                @click="$emit('deviceClick', $event)"
            ></Device>
        </template>
    </ui-Installation>
</template>

<script>
    import Installation from '../models/Installation';
    import Device from '../components/Device';
    import { MqttMixin } from '../mixins/MqttMixin';
    import { mapState } from 'vuex';

    export default {
        name: 'Installation',
        mixins: [MqttMixin],
        props: {
            installation: Object,
            active: Boolean,
            show: Boolean,
            hidden: Boolean,
            filtersSpaces: Array,
        },
        components: { Device },
        data: function() {
            return {
                devices: [],
                subscribed: false,
            };
        },
        mounted() {
            this.$store.commit('update', {
                [this.installation.reference]: new Installation(),
            });

            this.$onInstance('refresh', () => {
                this.init(
                    () => this.$emitInstance('startRefresh'),
                    () => this.$emitInstance('endRefresh')
                );
            });

            this.$onInstance(`reciveStatus_${this.installation.reference}`, () => this.status.setOutService(false));

            this.init();
        },
        methods: {
            init(callbackStart, callbackEND) {
                this.getDevices(callbackStart, callbackEND);
                if (this.isSubscribe(this.installation.reference)) this.orderStatus(callbackStart, callbackEND);
            },

            getDevices(callbackStart, callbackEND) {
                if (callbackStart) callbackStart();
                this.$api.getDevices(
                    this.installation.reference,
                    (data) => (this.devices = data.entity),
                    null,
                    callbackEND
                );
            },

            orderStatus(callbackStart, callbackEND) {
                if (callbackStart) callbackStart();

                this.getStatus(this.installation.reference, null, () => this.status.setOutService(true), callbackEND);
            },

            inFilterSpace() {
                return (
                    this.filtersSpaces.length == 0 || this.devices.some((x) => this.filtersSpaces.includes(x.space_id))
                    //this.installation.spaces.some((x) => this.filtersSpaces.includes(x.id))
                );
            },

            stop(status) {
                if (!status) {
                    let devicePrincipal = this.$fns.findByProperty(this.tStates, 'pl', '1');
                    this.status.off();
                    this.stopInstallation(
                        this.installation.reference,
                        devicePrincipal.rf,
                        (data) => dd(data),
                        () => this.status.on()
                    );
                }
            },

            setModeHeat(mode) {
                if (this.status.isOn()) this.$refs.alertModeChange.open();
                else this.status.setModeHeat(mode);
            },
        },
        filters: {
            toNumber(value) {
                return parseInt(value);
            },
        },
        watch: {
            show: {
                immediate: true,
                handler(val) {
                    if (val && !this.isSubscribe(this.installation.reference)) {
                        this.subscribed = true;
                        this.subscribe(this.installation.reference);
                        this.orderStatus();
                    }
                },
            },
        },
        computed: {
            ...mapState({
                status(state) {
                    return state.globalStatus[this.installation.reference] || new Installation();
                },
            }),
            tStates() {
                return this.status.devices || [];
            },
            modeHeat() {
                return this.status.isModeHeat && this.status.isModeHeat();
            },
            order() {
                let orders = this.$fns.uniqueByProperty(this.tStates, 'tc');
                if (orders.length == 1) return orders[0];
                return null;
            },
        },
    };
</script>
